<div class="title" mat-dialog-title>{{"CustomerMasterDataChange" | translate}}</div>
<mat-dialog-content>
	<div [innerText]="changeAddressText"></div>
</mat-dialog-content>
<mat-dialog-actions class="buttons">
  <button mat-raised-button color="primary" mat-dialog-close>{{"Close" | translate}}</button>
</mat-dialog-actions>
